import React from "react";
import { Helmet } from "react-helmet-async";

const PageTitle = ({ title, description, path,keywords }) => {
  const siteUrl = "https://yoga-shastra.com";
  const canonicalUrl = path ? `${siteUrl}${path}` : siteUrl;
  console.log('path',path);
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default PageTitle;
